import React from 'react'
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import { Box, Card, Typography } from '@mui/material'
import styled from '@emotion/styled'

const MainCard = styled(Card)(() => ({
  '.chart-title': {
    fontSize: 18,
    fontWeight: '600',
    padding: 7
    // padding: 18
  },
  '.parent-bar-chart': {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '12px 16px',
    background: '#F0F6FF',
    border: '1px solid #DEDEDE',
    // margin: "10px",
    width: '100%'
  },
  '.Overall': {
    fontSize: '16px',
    fontWeight: '600'
  },
  '.percentile': {
    fontSize: '18px',
    fontWeight: '700'
  }
}))
const ManufacturedBarChart = (props) => {
  const {
    title,
    // type = 'column',
    // data,
    // isGridLine = false,
    height,
    barChartData = true
  } = props
  const options = {
    chart: {
      type: 'column',
      height
    },
    exporting: {
      enabled: false // This disables the three dots menu
    },
    title: {
      text: ''
    },
    credits: { enabled: false },
    xAxis: {
      categories: ['D1', 'D1', 'D1', 'D1', 'D1'], // Repeated for demonstration
      title: {
        text: 'Manufactured Parts'
      }
    },
    yAxis: {
      min: 0,
      title: {
        text: 'Time'
      }
    },
    // legend: {
    //   layout: 'vertical',
    //   align: 'right',
    //   verticalAlign: 'middle'
    // },
    plotOptions: {
      column: {
        pointPadding: 0.2,
        borderWidth: 0
      }
    },
    series: [
      {
        name: 'Real Time',
        data: [15, 10, 20, 14, 15], // Example values
        color: '#FFDAB9' // Peach color
      },
      {
        name: 'Allocated Time',
        data: [25, 20, 28, 20, 18], // Example values
        color: '#ADD8E6' // Light blue
      }
    ]
  }

  return (
    <div className="App">
      <MainCard
        variant="standerd"
        sx={{ border: '1px solid #E6EAEF', padding: '15px 15px 0px 15px', borderRadius: '0px' }}
      >
        <Box sx={{ display: 'flex', justifyContent: 'space-between', paddingTop: '10px' }}>
        <Typography className="chart-title">{title}</Typography>
        </Box>

        <Box
          className={`${
            barChartData
              ? 'bar-chart-padding-dash'
              : 'column-chart-padding-dash'
          }`}
        >
          <HighchartsReact highcharts={Highcharts} options={options} />
        </Box>
      </MainCard>
    </div>
  )
}

export default ManufacturedBarChart
